import { notification } from "antd";
import 'antd/dist/reset.css';

const Notification = {

  success: (message, description) => {
    notification.success({
      message,
      description,
      placement: "topRight",
      duration: 2,
    });
  },

  error: (message, description) => {
    notification.error({
      message,
      description,
      placement: "topRight",
      duration: 2,
    });
  },

  warning: (message, description) => {
    notification.warning({
      message,
      description,
      placement: "topRight",
      duration: 2,
    });
  },

  info: (message, description) => {
    notification.info({
      message,
      description,
      placement: "topRight",
      duration: 2,
    });
  },

};

export default Notification;